import React from 'react';
import { SimpleDiffLine } from './simple-diff-line';

export const InvoiceItemDiffLine = ({
  item,
}: {
  item: {
    payCode?: string;
    effectiveHourlyRateCents: number;
    hours: number;
    totalSeconds: number;
  };
}) => {
  const currencyRate = item.effectiveHourlyRateCents / 100;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const payCode = item.payCode!;

  return (
    <SimpleDiffLine
      payCode={payCode}
      hours={item.totalSeconds}
      billingRate={currencyRate}
      billingAmount={currencyRate * item.hours}
    />
  );
};
